import React from "react";
import {
  Box,
  Flex,
  Text,
  SimpleGrid,
  Icon,
  Badge,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaGavel,
  FaShieldAlt,
} from "react-icons/fa";

function Footer() {
  const role = localStorage.getItem("role");
  const isAdminOrStaff = role === "ADMIN" || role === "staff";

  return (
    <Box bg="#0B132B" color="gray.300" pt="12" pb="6" borderTop="1px solid rgba(255,255,255,0.08)">
      <Box maxW="1360px" mx="auto" px={{ base: "4", md: "8" }}>
        {/* Main Footer Grid */}
        <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={{ base: 8, md: 10 }} mb="10">
          {/* Column 1: Brand & Bio */}
          <Box>
            <Flex align="center" gap="2.5" mb="3">
              <Box p="2" bg="yellow.500" rounded="lg" color="gray.950">
                <Icon as={FaGavel} boxSize="18px" />
              </Box>
              <Box>
                <Flex align="baseline">
                  <Text fontSize="18px" fontWeight="800" color="white">
                    Navneet Law
                  </Text>
                  <Text fontSize="18px" fontWeight="800" color="yellow.400" ml="1">
                    Studios
                  </Text>
                </Flex>
                <Text fontSize="10px" textTransform="uppercase" letterSpacing="0.5px" color="gray.400">
                  Private Limited
                </Text>
              </Box>
            </Flex>

            <Text fontSize="13px" color="gray.400" lineHeight="1.6" mb="4">
              India’s premier platform for legal literature, Supreme Court & High Court law reporters, advocate apparel, and state-of-the-art AI legal research tools.
            </Text>

            <Flex gap="3">
              <a
                href="https://www.facebook.com/profile.php?id=61572656670173"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <Box
                  p="2"
                  rounded="full"
                  bg="whiteAlpha.100"
                  _hover={{ bg: "#1877F2", color: "white" }}
                  transition="all 0.2s"
                >
                  <Icon as={FaFacebookF} boxSize="14px" />
                </Box>
              </a>
              <a
                href="https://www.instagram.com/navneetlawstudio_spark24/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <Box
                  p="2"
                  rounded="full"
                  bg="whiteAlpha.100"
                  _hover={{ bg: "#E4405F", color: "white" }}
                  transition="all 0.2s"
                >
                  <Icon as={FaInstagram} boxSize="14px" />
                </Box>
              </a>
              <a
                href="https://www.youtube.com/@NavneetLawStudio"
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
              >
                <Box
                  p="2"
                  rounded="full"
                  bg="whiteAlpha.100"
                  _hover={{ bg: "#CD201F", color: "white" }}
                  transition="all 0.2s"
                >
                  <Icon as={FaYoutube} boxSize="14px" />
                </Box>
              </a>
            </Flex>
          </Box>

          {/* Column 2: Quick Links */}
          <Box>
            <Text fontSize="14px" fontWeight="700" color="white" textTransform="uppercase" letterSpacing="0.8px" mb="4">
              Quick Navigation
            </Text>
            <Flex direction="column" gap="2.5" fontSize="13.5px">
              <Link to="/">
                <Text _hover={{ color: "yellow.400" }} transition="color 0.2s">Home</Text>
              </Link>
              <Link to="/products?maincat=Books">
                <Text _hover={{ color: "yellow.400" }} transition="color 0.2s">Book Store & Bare Acts</Text>
              </Link>
              <Link to="/products?maincat=Cloths-Accessories">
                <Text _hover={{ color: "yellow.400" }} transition="color 0.2s">Lawyers Clothing & Accessories</Text>
              </Link>
              <Link to="/software">
                <Text _hover={{ color: "yellow.400" }} transition="color 0.2s">Legal AI Software Suite</Text>
              </Link>
              <Link to="/orderpage">
                <Text _hover={{ color: "yellow.400" }} transition="color 0.2s">Track My Orders</Text>
              </Link>
              <Link to="/about">
                <Text _hover={{ color: "yellow.400" }} transition="color 0.2s">About Navneet Law Studios</Text>
              </Link>
              <Link to="/contact">
                <Text _hover={{ color: "yellow.400" }} transition="color 0.2s">Contact Customer Care</Text>
              </Link>
            </Flex>
          </Box>

          {/* Column 3: Legal & Policies */}
          <Box>
            <Text fontSize="14px" fontWeight="700" color="white" textTransform="uppercase" letterSpacing="0.8px" mb="4">
              Policies & Support
            </Text>
            <Flex direction="column" gap="2.5" fontSize="13.5px">
              <Link to="/shippingpolicy">
                <Text _hover={{ color: "yellow.400" }} transition="color 0.2s">Shipping & Refund Policy</Text>
              </Link>
              <Link to="/privacy">
                <Text _hover={{ color: "yellow.400" }} transition="color 0.2s">Privacy Policy</Text>
              </Link>
              <Link to="/termsandcondition">
                <Text _hover={{ color: "yellow.400" }} transition="color 0.2s">Terms & Conditions</Text>
              </Link>
              <Link to="/disclaimer">
                <Text _hover={{ color: "yellow.400" }} transition="color 0.2s">Disclaimer</Text>
              </Link>
              {isAdminOrStaff && (
                <Link to="/admin">
                  <Badge colorScheme="yellow" px="2" py="1" rounded="md" mt="2" display="inline-block">
                    ⚙️ Admin Panel
                  </Badge>
                </Link>
              )}
            </Flex>
          </Box>

          {/* Column 4: Contact & Office */}
          <Box>
            <Text fontSize="14px" fontWeight="700" color="white" textTransform="uppercase" letterSpacing="0.8px" mb="4">
              Registered Office
            </Text>

            <Flex direction="column" gap="3" fontSize="13px" color="gray.400">
              <Flex gap="2.5" align="flex-start">
                <Icon as={FaMapMarkerAlt} color="yellow.400" mt="1" boxSize="15px" />
                <Text lineHeight="1.5">
                  Building No./Flat No.: 4B-605, Plot No. R1, KH No. 6/1, SDPL Ashray, Beltarodi, Nagpur, Maharashtra - 440037
                </Text>
              </Flex>

              <Flex gap="2.5" align="center">
                <Icon as={FaPhoneAlt} color="yellow.400" boxSize="14px" />
                <Text>+91 9765010530</Text>
              </Flex>

              <Flex gap="2.5" align="center">
                <Icon as={FaEnvelope} color="yellow.400" boxSize="14px" />
                <Text>customercare@navneetlawstudio.com</Text>
              </Flex>

              <Flex gap="2.5" align="center">
                <Icon as={FaEnvelope} color="yellow.400" boxSize="14px" />
                <Text>sales@navneetlawstudio.com</Text>
              </Flex>
            </Flex>
          </Box>
        </SimpleGrid>

        {/* Bottom Bar: Copyright & Attribution */}
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align="center"
          pt="6"
          borderTop="1px solid rgba(255, 255, 255, 0.08)"
          gap="4"
          fontSize="12px"
          color="gray.500"
        >
          <Text textAlign={{ base: "center", md: "left" }}>
            © {new Date().getFullYear()} Navneet Law Studios Private Limited. All rights reserved.
          </Text>

          <Flex align="center" gap="4">
            <Text>
              Designed & Developed by{" "}
              <a
                href="https://kstartechnology.in/"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#EAB308", fontWeight: "600" }}
              >
                KStar Technology
              </a>
            </Text>

            <Flex align="center" gap="1.5" color="gray.400">
              <Icon as={FaShieldAlt} color="green.400" />
              <span>100% Safe & Secure Checkout</span>
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
}

export default Footer;
